import paths from '@rental-manager/pathsManifest';

export const WIZARD_CATEGORIES = [
  'Lease',
  'Rent details',
  'Move-in costs',
  'Tenant',
  'Verification',
  'Deposit account',
  'Review',
] as const;

export type WizardCategory = (typeof WIZARD_CATEGORIES)[number];

export type WizardScreenConfig = {
  title: string;
  /** null = flow entry: the stepper shows with the first visible category active and nothing complete. */
  category: WizardCategory | null;
  showStepper: boolean;
};

const screen = (title: string, category: WizardCategory | null, showStepper = true): WizardScreenConfig => ({
  title,
  category,
  showStepper,
});

export const WIZARD_SCREENS: Record<string, WizardScreenConfig> = {
  [paths.onboarding.checklistPage]: screen('Checklist', null),
  [paths.onboarding.emptyLeasePage]: screen('Empty lease', 'Lease', false),
  [paths.onboarding.leaseSelectorPage]: screen('Select lease', 'Lease'),
  [paths.onboarding.rentAmountPage]: screen('Rent amount', 'Rent details'),
  [paths.onboarding.dueDatePage]: screen('Due date', 'Rent details'),
  [paths.onboarding.termLengthPage]: screen('Term length', 'Rent details'),
  [paths.onboarding.moveInCostsPage]: screen('Move-in costs', 'Move-in costs'),
  [paths.onboarding.inviteTenantPage]: screen('Invite tenant', 'Tenant'),
  [paths.onboarding.taxVerificationPage]: screen('Tax verification', 'Verification'),
  [paths.onboarding.phoneVerificationPage]: screen('Phone verification', 'Verification'),
  [paths.onboarding.knowledgeBasedAuthenticationPage]: screen('Identity verification', 'Deposit account'),
  [paths.onboarding.accountInfoPage]: screen('Deposit account', 'Deposit account'),
  [paths.onboarding.confirmationPage]: screen('Review', 'Review'),
  [paths.onboarding.postConfirmationPage]: screen('Done', 'Review', false),
};

const normalize = (path: string): string => path.replace(/\/+$/, '');

export const getWizardScreen = (pathname: string): WizardScreenConfig | undefined => {
  const normalized = normalize(pathname);
  const match = Object.keys(WIZARD_SCREENS).find((path) => normalized.endsWith(normalize(path)));
  return match ? WIZARD_SCREENS[match] : undefined;
};
